import { ReactComponent as ViventiumLogo } from "Assets/WhiteLabelPartnerLogos/viventium-logo.svg";
import { ReactComponent as PNCLogo } from "Assets/WhiteLabelPartnerLogos/pnc-logo.svg";
import { ReactComponent as ADPLogo } from "Assets/WhiteLabelPartnerLogos/adp-logo.svg";
import { ReactComponent as DPLogo } from "Assets/dailypay-logo.svg";

export const whiteLabelPartners = {
  viventium: ViventiumLogo,
  dailypay: DPLogo,
  pnc: PNCLogo,
  adp_wisely: ADPLogo
};
